import { ReactNode, Key } from 'react';
import { DataNode } from 'antd/lib/tree';

export function includeTitle(searchValue: string, title?: ReactNode): boolean {
  if (typeof title === 'string' && title.includes(searchValue)) return true;
  return false;
}
export function getParentKey(
  tree: DataNode[],
  searchValue: string,
  parentKey: Key[],
): Key[] {
  tree.forEach(item => {
    if (includeTitle(searchValue, item.title as ReactNode)) parentKey.push(item.key);
    if (item.children) {
      getParentKey(item.children, searchValue, parentKey);
    }
  });
  return parentKey;
}
export function loop(data: DataNode[], searchValue?: string): DataNode[] {
  if (searchValue === undefined) return data;
  return data.map(item => {
    let title = item.title;
    if (typeof title === 'string') {
      const index = title.indexOf(searchValue);
      const beforeStr = title.substr(0, index);
      const afterStr = title.substr(index + searchValue.length);
      title =
        index > -1 ? (
          <span>
            {beforeStr}
            <span className="yb-tree-search-value">{searchValue}</span>
            {afterStr}
          </span>
        ) : (
          <span>{item.title as ReactNode}</span>
        );
      if (item.children) {
        return {
          ...item,
          title,
          key: item.key,
          children: loop(item.children, searchValue),
        };
      }
      return {
        ...item,
        title,
        key: item.key,
      };
    }
    return item;
  });
}
